import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { pct, rawValue, sliderCfg } from "../../lib/node";
import { useSetter } from "../../lib/useSetter";

export default function SliderWidget({
  node,
  ctx,
}: {
  node: INode;
  ctx: ServiceContextType;
}) {
  const { onRangeChange, disabled } = useSetter();
  const { min, max, step } = sliderCfg(node);
  const value = rawValue(ctx, node.addr, node.stateKey) ?? min;

  return (
    <div className="pt-4">
      <div className="text-right pr-3">{Math.round(pct(value, min, max))}%</div>
      <input
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={onRangeChange(node.addr, node.stateKey)}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 disabled:opacity-40"
      />
    </div>
  );
}
